"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitButton = SubmitButton;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const src_1 = require("..");
/** Provides a Button that will auto-disable if `formState` is invalid. */
function SubmitButton(props) {
    const { form, disabled, onClick, label = "Submit", ...others } = props;
    if (typeof onClick === "string") {
        throw new Error("SubmitButton.onClick doesn't support strings yet");
    }
    // Enable the button whenever the form is dirty, even if the form is partially invalid,
    // because submitting will then force-touch all fields and show all errors instead of
    // just errors-so-far.
    const dirty = (0, src_1.useComputed)(() => form.dirty, [form]);
    return ((0, jsx_runtime_1.jsx)(src_1.Button, { label: label, disabled: disabled || !dirty, onClick: (e) => {
            // canSave will touch any not-yet-keyed-in fields to show errors
            if (form.canSave()) {
                void onClick(e);
            }
        }, ...others }));
}
